import { AGENT_SHARED_FIELD } from '../constants';

export const generateSharedFieldValues = (fields, ownerId, ownerModel = 'Client', agentField = AGENT_SHARED_FIELD) => fields.reduce((acc, field) => {
  const { value = '', _id: fieldId } = field;
  if (value !== '') {
    acc.push({
      field: fieldId,
      value,
      ownerId,
      ownerModel,
    });
  }
  return acc;
}, [{ ...agentField, ownerId }]);

export const cleanPhonePrefix = (phone) => phone.replace('+521', '');
